import { MaestroApi } from './api';

export default async function fetchChannelData({ accessToken }) {
	const res = await MaestroApi.get('/marketplacecountryvista', {
		headers: {
			Authorization: `Bearer ${accessToken}`,
			accept: '*/*',
		},
	});

	return res?.data || [];
}
